import {
  unionFlag,
  getCookie,
  getQueryString,
  convertParam,
  getLocalStorage,
  getSessonStorage
} from '@/utils';
import device from '@/utils/device';
import { Toast } from 'antd-mobile';
import { BFD_checkApp, BFD_LoginOut } from '@/utils/bfdApp';
import { TLang } from '@/utils/lang';
import DFWebUtilsTools from '@df-fe/df-web-utils-tools';
import { safeJsonParse } from '@/utils/safeJsonParse';

export interface ResponseBasic {
  /** 状态 */
  Status: number;
  /** 消息 */
  Message?: string;
  /** 数据结果 */
  Data?: any;
  /** 数据总数 */
  TotalCount?: number;
}
export enum ApiVersion {
  v0 = "before",
  v1 = "20230727",
}

/**
 * 根据对象解析成url参数
 * @param params 参数对象
 */
function strToJson(str) {
  try {
    return JSON.parse(str);
  } catch {
    return str;
  }
}
const _window: any = window;
export function getUrlParamsByObject(params: any) {
  if (typeof params === 'undefined' || params === null) {
    return '';
  } else if (typeof params === 'string') {
    return params;
  } else {
    let keys = Object.keys(params);
    let urlParams = '';
    keys.map((key) => {
      urlParams += `&${key}=${params[key]}`;
    });
    return urlParams;
  }
}
export default class ApiHttpHelper {
  isMock = false;
  constructor(isMock: boolean = false) {
    this.isMock = isMock;
  }
  Get(url: string, params?: any, headers?: object, async: boolean = false): Promise<ResponseBasic> {
    return new Promise<ResponseBasic>(
      (
        resolve: (response: ResponseBasic) => void,
        reject: (errorResponse?: ResponseBasic) => void,
      ) => {
        let item: ResponseBasic = {
          Status: -1
        };

        if (process.env.apiType === 'mock' || this.isMock) {
          item = this.getMockData(url, item);
          const time = parseInt((Math.random() * 4000).toString());
          setTimeout(() => {
            resolve(item);
          }, time);
          return;
        }
        try {
          let xhr = new XMLHttpRequest();
          xhr.open('get', this.urlHandler(url) + getUrlParamsByObject(params), async);
          this.setHeader({ ...headers, ..._window?.__df_channel_sdk?.getRequestHeader() }, xhr);
          xhr.send();
          item.Status = xhr.status;

          xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
              if (xhr.status === 200) {
                let obj = strToJson(xhr.responseText);
                item.Data = obj;
                // 体验码 游客模式弹窗
                if (obj && (obj.code === 1000000 || obj.code === 1000001)) {
                  const loginInfo: any = JSON.parse(getSessonStorage('loginInfo') || '{}');
                  const _window: any = window;
                  _window.dfShowGuestModal((type) => {
                    // 对应处理逻辑
                    if (type === 'cancel') {
                      const _path = _window.location.pathname;
                      switch (_path) {
                        case '/newmovie/order/confirm':
                        case '/newmovie/movieSeat':
                        case '/newmovie/order/status':
                          _window.history.back();
                          break;
                        default:
                          console.log('停留当前页面不处理');
                          break;
                      }
                    }
                  }, loginInfo?.loginUrl, obj.code);
                }
                resolve(item);
              } else {
                reject(item);
              }
            }
          };
        } catch (e) {
          item.Message = e.message;
          reject(item);
        }
      },
    );
  }
  Post(
    url: string,
    params?: any,
    applicationType: boolean = false,
    headers?: object,
    version: ApiVersion = ApiVersion.v0,
    timeout?: any,
  ): Promise<ResponseBasic> {
    return new Promise<ResponseBasic>(
      (
        resolve: (response: ResponseBasic) => void,
        reject: (errorResponse?: ResponseBasic) => void,
      ) => {
        let item: ResponseBasic = {
          Status: -1
        };
        if (process.env.apiType === 'mock' || this.isMock) {
          item = this.getMockData(url, item);
          const time = parseInt((Math.random() * 4000).toString());
          setTimeout(() => {
            resolve(item);
          }, time);
          return;
        }
        try {
          let xhr = new XMLHttpRequest();

          // 携带cookie
          xhr.withCredentials = true;

          xhr.open('POST', this.urlHandler(url), true);
          xhr = this.setHeader({ ...headers, ..._window?.__df_channel_sdk?.getRequestHeader() }, xhr, applicationType);
          // console.log(this.bodyHandler(params, applicationType),this.urlHandler(url))
          xhr.send(this.bodyHandler(params, applicationType));
          item.Status = xhr.status;
          // if (xhr.status === 200) {
          //   let obj = this.strToJson(xhr.responseText);
          //   if (obj && (obj.code == 101002 || obj.code == 121001)) {
          //     // 状态为 未登录，需要跳转登录.  **** 该功能需要测试 ****
          //     // const loginInfo: any = JSON.parse(getSessonStorage('loginInfo') || '');
          //     // // console.log(loginInfo);
          //     // if (loginInfo && loginInfo.loginUrl) {
          //     //   return Toast.info('请重新登录', 0.8, () => {
          //     //     window.location.replace(
          //     //       loginInfo.loginUrl + '&returnUrl=' + window.location.href,
          //     //     );
          //     //   });
          //     // }

          //     const isBFDAPP = BFD_checkApp();
          //     try {
          //       if (isBFDAPP) {
          //         BFD_LoginOut();
          //       } else {
          //         const loginInfo: any = JSON.parse(getSessonStorage('loginInfo') || '');
          //         // console.log(loginInfo);
          //         if (loginInfo && loginInfo.loginUrl) {
          //           return Toast.info(TLang('请重新登录', 'home', false, false, null), 0.8, () => {
          //             window.location.replace(
          //               loginInfo.loginUrl + '&returnUrl=' + window.location.href,
          //             );
          //           });
          //         }
          //       }
          //     } catch (e) {
          //       const loginInfo: any = JSON.parse(getSessonStorage('loginInfo') || '');
          //       // console.log(loginInfo);
          //       if (loginInfo && loginInfo.loginUrl) {
          //         return Toast.info(TLang('请重新登录', 'home', false, false, null), 0.8, () => {
          //           window.location.replace(
          //             loginInfo.loginUrl + '&returnUrl=' + window.location.href,
          //           );
          //         });
          //       }
          //     }
          //   }
          //   if (typeof obj === 'object') {
          //     item.Data = obj.body ? obj.body : obj;
          //     item.Status = obj.respCode ? obj.respCode : obj.code;
          //     item.Message = obj.respMsg || obj.msg || obj.message ;
          //   } else {
          //     item.Data = obj;
          //   }
          //   resolve(item);
          // } else {
          //   reject(item);
          // }
          function cb() {
            if (xhr.status === 200) {
              let obj = strToJson(xhr.responseText);
              if (obj && (obj.code == 101002 || obj.code == 121001)) {
                // 状态为 未登录，需要跳转登录.  **** 该功能需要测试 ****
                // const loginInfo: any = JSON.parse(getSessonStorage('loginInfo') || '');
                // // console.log(loginInfo);
                // if (loginInfo && loginInfo.loginUrl) {
                //   return Toast.info('请重新登录', 0.8, () => {
                //     window.location.replace(
                //       loginInfo.loginUrl + '&returnUrl=' + window.location.href,
                //     );
                //   });
                // }

                const isBFDAPP = BFD_checkApp();
                try {
                  const _win: any = window;
                  if (
                    _win.__wxjs_environment === "miniprogram"
                  ) {
                    // 跳转小程序
                    return _win.wx.miniProgram.redirectTo({ url: "/pages/login/login" });
                  } else if (isBFDAPP) {
                    BFD_LoginOut();
                  } else {
                    const loginInfo: any = JSON.parse(getSessonStorage('loginInfo') || '');
                    // console.log(loginInfo);
                    if (loginInfo && loginInfo.loginUrl) {
                      return Toast.info(TLang('请重新登录', 'home', false, false, null), 0.8, () => {
                        window.df_sdk_common.location.replace(
                          loginInfo.loginUrl + '&returnUrl=' + window.location.href,
                        );
                      });
                    }
                  }
                } catch (e) {
                  const loginInfo: any = JSON.parse(getSessonStorage('loginInfo') || '');
                  // console.log(loginInfo);
                  if (loginInfo && loginInfo.loginUrl) {
                    return Toast.info(TLang('请重新登录', 'home', false, false, null), 0.8, () => {
                      window.df_sdk_common.location.replace(
                        loginInfo.loginUrl + '&returnUrl=' + window.location.href,
                      );
                    });
                  }
                }
              }
              // 体验码 游客模式弹窗
              if (obj && (obj.code === 1000000 || obj.code === 1000001)) {
                const loginInfo: any = JSON.parse(getSessonStorage('loginInfo') || '{}');
                const _window: any = window;
                _window.dfShowGuestModal((type) => {
                  // 对应处理逻辑
                  if (type === 'cancel') {
                    const _path = _window.location.pathname;
                    switch (_path) {
                      case '/newmovie/order/confirm':
                      case '/newmovie/movieSeat':
                      case '/newmovie/order/status':
                        _window.history.back();
                        break;
                      default:
                        console.log('停留当前页面不处理');
                        break;
                    }
                  }
                }, loginInfo?.loginUrl, obj.code);
              }
              if (typeof obj === 'object') {
                if (version === ApiVersion.v1) {
                  item.Data = obj.body
                } else {
                  item.Data = obj.body ? obj.body : obj;
                }
                item.Status = obj.respCode ? obj.respCode : obj.code;
                item.Message = obj.respMsg || obj.msg || obj.message;
              } else {
                item.Data = obj;
              }
              resolve(item);
            } else {
              reject(item);
            }
          }
          xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
              cb();
            }
          };
          if (timeout && url.indexOf('/session/selectseat') > -1) {
            setTimeout(() => {
              resolve({
                Status: 0,
                Data: "timeout",
              })
              xhr.abort();
            }, timeout);
          }
        } catch (e) {
          item.Message = e.message;
          reject(item);
        }
      },
    );
  }
  PostNew(url: string, data?: any, config?: {
    applicationType?: boolean,
    headers?: object,
    version?: ApiVersion
  }) {
    return this.Post(url, data, config?.applicationType, config?.headers, config?.version)
  }
  /**
   * 获取服务器时间
   * @param url 需要请求的服务器URL,为空默认取当前
   */
  GetUrlTime(url?: string): Promise<ResponseBasic> {
    return new Promise<ResponseBasic>(
      (
        resolve: (response: ResponseBasic) => void,
        reject: (errorResponse?: ResponseBasic) => void,
      ) => {
        let item: ResponseBasic = {
          Status: -1
        };
        try {
          let u = url || window.location.origin || process.env.BASIC_URL || '';
          let xhr = new XMLHttpRequest();
          xhr.open('HEAD', this.urlHandler(u), false);
          xhr.send(this.bodyHandler(null));
          item.Status = xhr.status;
          // if (xhr.status === 200) {
          //   let serverDate = xhr.getResponseHeader('Date');
          //   if (serverDate) {
          //     let formaterDate = new Date(serverDate);
          //     let time = {
          //       year: formaterDate.getFullYear(),
          //       month: ('0' + (formaterDate.getMonth() + 1)).slice(-2),
          //       day: ('0' + formaterDate.getDate()).slice(-2),
          //       hours: ('0' + formaterDate.getHours()).slice(-2),
          //       minutes: ('0' + formaterDate.getMinutes()).slice(-2),
          //       seconds: ('0' + formaterDate.getSeconds()).slice(-2)
          //     };
          //     item.Data = time;
          //   }
          //   resolve(item);
          // } else {
          //   reject(item);
          // }
          function cb() {
            if (xhr.status === 200) {
              let serverDate = xhr.getResponseHeader('Date');
              if (serverDate) {
                let formaterDate = new Date(serverDate);
                let time = {
                  year: formaterDate.getFullYear(),
                  month: ('0' + (formaterDate.getMonth() + 1)).slice(-2),
                  day: ('0' + formaterDate.getDate()).slice(-2),
                  hours: ('0' + formaterDate.getHours()).slice(-2),
                  minutes: ('0' + formaterDate.getMinutes()).slice(-2),
                  seconds: ('0' + formaterDate.getSeconds()).slice(-2)
                };
                item.Data = time;
              }
              resolve(item);
            } else {
              reject(item);
            }
          }
          xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
              cb();
            }
          };

        } catch (e) {
          item.Message = e.message;
          reject(item);
        }
      },
    );
  }
  /**
   * 上传
   * @param url
   * @param params
   * @param headers
   * @param async
   */
  Upload(url: string, params?: any): Promise<ResponseBasic> {
    return new Promise<ResponseBasic>(
      (
        resolve: (response: ResponseBasic) => void,
        reject: (errorResponse?: ResponseBasic) => void,
      ) => {
        let item: ResponseBasic = {
          Status: -1
        };
        try {
          let xhr = new XMLHttpRequest();
          xhr.open('POST', url);
          xhr.responseType = 'json';
          xhr.send(params);
          item.Status = xhr.status;
          if (xhr.status === 200) {
            let obj = this.strToJson(xhr.responseText);
            if (typeof obj === 'object') {
              item.Data = obj.data;
              item.Message = obj.msg;
            } else {
              item.Data = obj;
            }
            resolve(item);
          } else {
            reject(item);
          }
          function cb() {
            if (xhr.status === 200) {
              let obj = strToJson(xhr.responseText);
              if (typeof obj === 'object') {
                item.Data = obj.data;
                item.Message = obj.msg;
              } else {
                item.Data = obj;
              }
              resolve(item);
            } else {
              reject(item);
            }
          }
          xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
              cb();
            }
          };
        } catch (e) {
          item.Message = e.message;
          reject(item);
        }
      },
    );
  }
  strToJson(str: string) {
    try {
      return JSON.parse(str);
    } catch {
      return str;
    }
  }

  bodyHandler = (params: any, applicationType: boolean = true) => {
    // 处理百福德

    let union = unionFlag() || getSessonStorage('dffl_union');
    let unionParams: any = {};
    // debugger
    if (union && union !== 'null') {
      let item = {
        union: union,
        unionFlag: 1,
        ignore: false
      };
      unionParams = Object.assign(unionParams, item);
    }
    if (params?.union === 'null') {
      delete params?.union;
    }
    const isBili = getSessonStorage('isBilingual') || 'false';
    if (isBili && isBili != 'null' && isBili != 'undefined') {
      unionParams.isBilingual = isBili;
    }

    let cityId = 145;
    const localAddress = safeJsonParse(DFWebUtilsTools.getCatchAddress());
    const address = getSessonStorage('currentAddress');
    if (address) {
      cityId = localAddress && localAddress?.cityId ? localAddress?.cityId : JSON.parse(address).cityId;
    }
    if (typeof params === 'undefined' || params === null) {
      if (applicationType) {
        return `cityId=${cityId}&platform=1&isBilingual=${isBili}`;
      } else {
        unionParams.cityId = cityId;
        unionParams.platform = 1;
        return JSON.stringify(unionParams);
      }
    } else if (typeof params === 'string') {
      return params + `&cityId=${cityId}&platform=1&isBilingual=${isBili}`;
    } else {
      unionParams = Object.assign(unionParams, params);
      unionParams.cityId = cityId;
      unionParams.city = cityId;
      unionParams.platform = 1;
      if (applicationType) {
        return convertParam(unionParams);
      } else {
        return JSON.stringify(unionParams);
      }
    }
  };
  /**写入header */
  setHeader = (objs: any, xhr: XMLHttpRequest, applicationType: boolean = true) => {
    let application = '';

    if (applicationType) {
      application = 'application/x-www-form-urlencoded;';
    } else {
      application = 'application/json;';
    }
    const _window: any = window;
    const terminal = window.navigator.userAgent.indexOf('MAX-APP') > -1 ? 'maxapp' : null
    xhr.setRequestHeader('terminal', `${terminal}`);
    xhr.setRequestHeader('content-Type', `${application}`);
    if (!objs) {
      return xhr;
    }
    let keys = Object.keys(objs);
    keys.map((key: string) => {
      let val = objs[key];
      xhr.setRequestHeader(key, val);
    });

    return xhr;
  };
  /**请求地址处理处理 */
  urlHandler = (apiUrl: string) => {
    let basic_url = process.env.BASIC_URL;
    let c = new Date();
    if (apiUrl.indexOf('?') < 0) {
      apiUrl += `?timestamp=${c.getTime()}`;
    } else {
      apiUrl += `&timestamp=${c.getTime()}`;
    }

    // if (apiUrl.indexOf('http') > -1 || apiUrl.indexOf('https') > -1) {
    // return apiUrl;
    // } else {
    // return basic_url + apiUrl;
    return apiUrl;
    // }
  };
  /** mock数据 */
  getMockData = (url, item) => {
    console.log('mock数据');
    item.Status = 200;
    const key = url.substr(url.lastIndexOf('/') + 1, url.length);
    // item.Data = mockData[key];
    return item;
  };
}
